import React, { useMemo, Children } from 'react';
import { useInView } from '../../hooks/useInView';
interface AnimateProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  style?: React.CSSProperties;
  as?: keyof JSX.IntrinsicElements;
}
const directionOffset: Record<string, string> = {
  up: 'translateY(24px)',
  down: 'translateY(-24px)',
  left: 'translateX(40px)',
  right: 'translateX(-40px)',
  none: 'none'
};
export function Animate({
  children,
  className = '',
  delay = 0,
  direction = 'up',
  style,
  as: Tag = 'div'
}: AnimateProps) {
  const [ref, inView] = useInView();
  // Memoize style to avoid object recreation on every render
  const baseStyle = useMemo<React.CSSProperties>(() => ({
    opacity: inView ? 1 : 0,
    transform: inView ? 'none' : directionOffset[direction],
    transition: `opacity 0.5s ease ${delay}s, transform 0.5s ease ${delay}s`,
    willChange: inView ? 'auto' : 'opacity, transform',
    ...style
  }), [inView, direction, delay, style]);
  return (
    // @ts-ignore
    <Tag ref={ref} className={className} style={baseStyle} data-id="element-177">
      {children}
    </Tag>
  );
}
interface StaggerProps {
  children: React.ReactNode;
  className?: string;
  staggerDelay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function Stagger({
  children,
  className = '',
  staggerDelay = 0.1,
  direction = 'up'
}: StaggerProps) {
  const [ref, inView] = useInView();
  const items = Children.toArray(children);
  return <div ref={ref} className={className} data-id="element-178">
      {items.map((child, i) => {
      const d = i * staggerDelay;
      return <div key={i} style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'none' : direction === 'up' ? 'translateY(24px)' : direction === 'left' ? 'translateX(40px)' : 'none',
        transition: `opacity 0.5s ease ${d}s, transform 0.5s ease ${d}s`,
        willChange: inView ? 'auto' : 'opacity, transform'
      }} data-id="element-179">
            {child}
          </div>;
    })}
    </div>;
}